var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineQuoteUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.58 21.47c-1.83 0-3.33-1.49-3.33-3.33v-5.8c0-.41.34-.75.75-.75h5.8c1.9 0 3.33 1.43 3.33 3.33v3.22c-.01 1.9-1.44 3.33-3.33 3.33H4.58zm-1.83-3.32c0 1.01.82 1.83 1.83 1.83H7.8c1.06 0 1.83-.77 1.83-1.83v-3.22c0-1.06-.77-1.83-1.83-1.83H2.75v5.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 12.35c0-6.25 1.27-7.56 4.9-9.71.36-.21.82-.09 1.03.26.21.36.09.82-.26 1.03-3.24 1.92-4.17 2.72-4.17 8.42 0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.201 21.47c-1.83 0-3.33-1.49-3.33-3.33v-5.8c0-.41.34-.75.75-.75h5.8c1.9 0 3.33 1.43 3.33 3.33v3.22c0 1.9-1.43 3.33-3.33 3.33h-3.22zm-1.82-3.32c0 1.01.82 1.83 1.83 1.83h3.22c1.06 0 1.83-.77 1.83-1.83v-3.22c0-1.06-.77-1.83-1.83-1.83h-5.05v5.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.879 12.35c0-6.25 1.27-7.56 4.9-9.71.36-.21.82-.09 1.03.26.21.36.09.82-.26 1.03-3.24 1.92-4.17 2.72-4.17 8.42 0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineQuoteUp);
export default __webpack_public_path__ + "static/media/vuesax-outline-quote-up.0b7e28a6e5bc9ecef2466a94017d5fb3.svg";
export { ForwardRef as ReactComponent };